var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b5b5b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slider") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0Zm0,54A26,26,0,1,1,54,28,26,26,0,0,1,28,54Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.29,18.4H43.6V16.71a.71.71,0,0,0-.71-.71H41.2V14.31a.71.71,0,0,0-.71-.71h-25a.71.71,0,0,0-.71.71V16H13.11a.71.71,0,0,0-.71.71V18.4H10.71a.71.71,0,0,0-.71.71V36.89a.71.71,0,0,0,.71.71H12.4v1.69a.71.71,0,0,0,.71.71H14.8v1.69a.71.71,0,0,0,.71.71h25a.71.71,0,0,0,.71-.71V40h1.69a.71.71,0,0,0,.71-.71V37.6h1.69a.71.71,0,0,0,.71-.71V19.11A.71.71,0,0,0,45.29,18.4ZM11.2,36.4V19.6h1.2V36.4Zm2.4,2.4V17.2h1.2V38.8ZM40,41.2H16V14.8H40V41.2Zm2.4-2.4H41.2V17.2h1.2V38.8Zm2.4-2.4H43.6V19.6h1.2Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.59,29.6A.41.41,0,0,0,24,29l-4.1,4.1a.41.41,0,0,0-.12.29h0a.4.4,0,0,0,.17.33L24,37.81a.41.41,0,1,0,.58-.58l-3.39-3.39H35.8a.41.41,0,0,0,0-.82H21.18Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.41,26.4A.41.41,0,0,0,32,27l4.1-4.1a.41.41,0,0,0,.12-.29h0a.4.4,0,0,0-.17-.33L32,18.19a.41.41,0,1,0-.58.58l3.39,3.39H20.2a.41.41,0,0,0,0,.82H34.82Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.df47c16bb7a8144ae0c7ca356fe85340.svg";
export { ForwardRef as ReactComponent };